import { render, staticRenderFns } from "./DynamicMessage.vue?vue&type=template&id=03cfc17e&scoped=true&lang=html"
import script from "./DynamicMessage.vue?vue&type=script&lang=js"
export * from "./DynamicMessage.vue?vue&type=script&lang=js"
import style0 from "./DynamicMessage.vue?vue&type=style&index=0&id=03cfc17e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cfc17e",
  null
  
)

export default component.exports